// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3VnYR","errorLogs":"EditorFooter_errorLogs__1fnsS"};